import { Feed } from "@/services/graphApi/graphql-zeus";
import { Icon } from "@/views";
import React from "react";
import { AccessType } from "../../Accesses";

type Type =
	| "awsProject"
	| "apple"
	| "appsFlyer"
	| "facebook"
	| "fairbid"
	| "googleAdwords"
	| "googlePlay"
	| "harvest"
	| "snapchat"
	| "tiktok"
	| "unity"
	| "default";

export const FeedIcon = ({ type }: { type: Type }) => {
	if (type === "awsProject") {
		return (
			<svg
				width="40"
				height="40"
				viewBox="0 0 304 182"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<path
						fill="#252F3E"
						d="M86.4,66.4c0,3.7,0.4,6.7,1.1,8.9c0.8,2.2,1.8,4.6,3.2,7.2c0.5,0.8,0.7,1.6,0.7,2.3c0,1-0.6,2-1.9,3l-6.3,4.2
		c-0.9,0.6-1.8,0.9-2.6,0.9c-1,0-2-0.5-3-1.4C76.2,90,75,88.4,74,86.8c-1-1.7-2-3.6-3.1-5.9c-7.8,9.2-17.6,13.8-29.4,13.8
		c-8.4,0-15.1-2.4-20-7.2c-4.9-4.8-7.4-11.2-7.4-19.2c0-8.5,3-15.4,9.1-20.6c6.1-5.2,14.2-7.8,24.5-7.8c3.4,0,6.9,0.3,10.6,0.8
		c3.7,0.5,7.5,1.3,11.5,2.2v-7.3c0-7.6-1.6-12.9-4.7-16c-3.2-3.1-8.6-4.6-16.3-4.6c-3.5,0-7.1,0.4-10.8,1.3c-3.7,0.9-7.3,2-10.8,3.4
		c-1.6,0.7-2.8,1.1-3.5,1.3c-0.7,0.2-1.2,0.3-1.6,0.3c-1.4,0-2.1-1-2.1-3.1v-4.9c0-1.6,0.2-2.8,0.7-3.5c0.5-0.7,1.4-1.4,2.8-2.1
		c3.5-1.8,7.7-3.3,12.6-4.5c4.9-1.3,10.1-1.9,15.6-1.9c11.9,0,20.6,2.7,26.2,8.1c5.5,5.4,8.3,13.6,8.3,24.6V66.4z M45.8,81.6
		c3.3,0,6.7-0.6,10.3-1.8c3.6-1.2,6.8-3.4,9.5-6.4c1.6-1.9,2.8-4,3.4-6.4c0.6-2.4,1-5.3,1-8.7v-4.2c-2.9-0.7-6-1.3-9.2-1.7
		c-3.2-0.4-6.3-0.6-9.4-0.6c-6.7,0-11.6,1.3-14.9,4c-3.3,2.7-4.9,6.5-4.9,11.5c0,4.7,1.2,8.2,3.7,10.6
		C37.7,80.4,41.2,81.6,45.8,81.6z M126.1,92.4c-1.8,0-3-0.3-3.8-1c-0.8-0.6-1.5-2-2.1-3.9L96.7,10.2c-0.6-2-0.9-3.3-0.9-4
		c0-1.6,0.8-2.5,2.4-2.5h9.8c1.9,0,3.2,0.3,3.9,1c0.8,0.6,1.4,2,2,3.9l16.8,66.2l15.6-66.2c0.5-2,1.1-3.3,1.9-3.9c0.8-0.6,2.2-1,4-1
		h8c1.9,0,3.2,0.3,4,1c0.8,0.6,1.5,2,1.9,3.9l15.8,67l17.3-67c0.6-2,1.3-3.3,2-3.9c0.8-0.6,2.1-1,3.9-1h9.3c1.6,0,2.5,0.8,2.5,2.5
		c0,0.5-0.1,1-0.2,1.6c-0.1,0.6-0.3,1.4-0.7,2.5l-24.1,77.3c-0.6,2-1.3,3.3-2.1,3.9c-0.8,0.6-2.1,1-3.8,1h-8.6c-1.9,0-3.2-0.3-4-1
		c-0.8-0.7-1.5-2-1.9-4L156,23l-15.4,64.4c-0.5,2-1.1,3.3-1.9,4c-0.8,0.7-2.2,1-4,1H126.1z M254.6,95.1c-5.2,0-10.4-0.6-15.4-1.8
		c-5-1.2-8.9-2.5-11.5-4c-1.6-0.9-2.7-1.9-3.1-2.8c-0.4-0.9-0.6-1.9-0.6-2.8v-5.1c0-2.1,0.8-3.1,2.3-3.1c0.6,0,1.2,0.1,1.8,0.3
		c0.6,0.2,1.5,0.6,2.5,1c3.4,1.5,7.1,2.7,11,3.5c4,0.8,7.9,1.2,11.9,1.2c6.3,0,11.2-1.1,14.6-3.3c3.4-2.2,5.2-5.4,5.2-9.5
		c0-2.8-0.9-5.1-2.7-7c-1.8-1.9-5.2-3.6-10.1-5.2L246,52c-7.3-2.3-12.7-5.7-16-10.2c-3.3-4.4-5-9.3-5-14.5c0-4.2,0.9-7.9,2.7-11.1
		c1.8-3.2,4.2-6,7.2-8.2c3-2.3,6.4-4,10.4-5.2c4-1.2,8.2-1.7,12.6-1.7c2.2,0,4.5,0.1,6.7,0.4c2.3,0.3,4.4,0.7,6.5,1.1
		c2,0.5,3.9,1,5.7,1.6c1.8,0.6,3.2,1.2,4.2,1.8c1.4,0.8,2.4,1.6,3,2.5c0.6,0.8,0.9,1.9,0.9,3.3v4.7c0,2.1-0.8,3.2-2.3,3.2
		c-0.8,0-2.1-0.4-3.8-1.2c-5.7-2.6-12.1-3.9-19.2-3.9c-5.7,0-10.2,0.9-13.3,2.8c-3.1,1.9-4.7,4.8-4.7,8.9c0,2.8,1,5.2,3,7.1
		c2,1.9,5.7,3.8,11,5.5l14.2,4.5c7.2,2.3,12.4,5.5,15.5,9.6c3.1,4.1,4.6,8.8,4.6,14c0,4.3-0.9,8.2-2.6,11.6
		c-1.8,3.4-4.2,6.4-7.3,8.8c-3.1,2.5-6.8,4.3-11.1,5.6C264.4,94.4,259.7,95.1,254.6,95.1z"
					/>
					<g>
						<path
							fill="#FF9900"
							clipRule="evenodd"
							fillRule="evenodd"
							d="M273.5,143.7c-32.9,24.3-80.7,37.2-121.8,37.2c-57.6,0-109.5-21.3-148.7-56.7c-3.1-2.8-0.3-6.6,3.4-4.4
			c42.4,24.6,94.7,39.5,148.8,39.5c36.5,0,76.6-7.6,113.5-23.2C274.2,133.6,278.9,139.7,273.5,143.7z"
						/>
						<path
							fill="#FF9900"
							clipRule="evenodd"
							fillRule="evenodd"
							d="M287.2,128.1c-4.2-5.4-27.8-2.6-38.5-1.3c-3.2,0.4-3.7-2.4-0.8-4.5c18.8-13.2,49.7-9.4,53.3-5
			c3.6,4.5-1,35.4-18.6,50.2c-2.7,2.3-5.3,1.1-4.1-1.9C282.5,155.7,291.4,133.4,287.2,128.1z"
						/>
					</g>
				</g>
			</svg>
		);
	}

	if (type === "apple") {
		return (
			<svg
				width="25"
				height="30"
				viewBox="0 0 25 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M13.499 2.61067C15.4708 0.0126657 18.2121 0 18.2121 0C18.2121 0 18.6198 2.44257 16.6609 4.79554C14.5693 7.30799 12.1919 6.89687 12.1919 6.89687C12.1919 6.89687 11.7455 4.92092 13.499 2.61067ZM12.4427 8.60788C13.4571 8.60788 15.3398 7.21396 17.7904 7.21396C22.0086 7.21396 23.6681 10.2145 23.6681 10.2145C23.6681 10.2145 20.4225 11.8733 20.4225 15.8983C20.4225 20.4389 24.4656 22.0038 24.4656 22.0038C24.4656 22.0038 21.6393 29.9559 17.8218 29.9559C16.0684 29.9559 14.7052 28.7748 12.8578 28.7748C10.9751 28.7748 9.10683 30 7.88999 30C4.40401 30.0001 0 22.4566 0 16.3929C0 10.4271 3.72771 7.29755 7.22414 7.29755C9.49714 7.29755 11.261 8.60788 12.4427 8.60788Z"
					fill="#999999"
				/>
			</svg>
		);
	}

	if (type === "appsFlyer") {
		return (
			<svg
				width="27"
				height="30"
				viewBox="0 0 27 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.128353 9.54423L4.59068 17.2629C4.89536 17.7888 5.64636 18.2156 6.26673 18.2142L15.3698 18.1968C15.9913 18.1956 16.2477 17.7677 15.9433 17.241L11.4805 9.52268C11.1761 8.99581 10.4252 8.57014 9.80427 8.57138L0.701319 8.58856C0.687275 8.58856 0.673686 8.58898 0.659642 8.58898C0.0690992 8.60923 -0.169637 9.02921 0.128353 9.54423Z"
					fill="#75B82C"
				/>
				<path
					d="M17.2217 18.9101L19.9297 24.0188C20.1139 24.3673 20.5644 24.647 20.9354 24.6428L26.3705 24.5847C26.7416 24.5809 26.8913 24.2951 26.7072 23.9464L24.0002 18.8381C23.8156 18.4894 23.3645 18.2103 22.9944 18.2143L17.5592 18.272C17.5528 18.272 17.5469 18.272 17.5405 18.272C17.1832 18.2854 17.0404 18.5668 17.2217 18.9101Z"
					fill="#75B82C"
				/>
				<path
					d="M17.037 0.310192L12.0728 7.30298C11.7335 7.78073 11.6885 8.63684 11.9718 9.21763L16.1222 17.7182C16.405 18.298 16.9097 18.3816 17.2484 17.9051L22.2132 10.9109C22.5518 10.4341 22.5973 9.57696 22.3134 8.99671L18.1637 0.495895C17.9992 0.160369 17.7613 -0.00879205 17.5241 0.000294054C17.3519 0.00798245 17.1797 0.109341 17.037 0.310192Z"
					fill="#3D90D5"
				/>
				<path
					d="M16.0085 19.4686L13.0292 23.582C12.8253 23.8629 12.799 24.3669 12.9686 24.7077L15.4588 29.7081C15.6292 30.0495 15.9315 30.0985 16.1351 29.8177L19.1135 25.7047C19.3166 25.4233 19.3437 24.9189 19.1743 24.5786L16.6839 19.578C16.5859 19.3805 16.4427 19.2809 16.3001 19.2859C16.1972 19.2898 16.0934 19.3498 16.0085 19.4686Z"
					fill="#3D90D5"
				/>
			</svg>
		);
	}

	if (type === "facebook") {
		return (
			<svg
				width="30"
				height="30"
				viewBox="0 0 30 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
					fill="#3C5A9A"
				/>
				<path
					d="M19.8772 4.60425H16.5543C14.5824 4.60425 12.3891 5.4336 12.3891 8.29196C12.3988 9.28792 12.3891 10.2418 12.3891 11.3152H10.1079V14.9453H12.4597V25.3958H16.7813V14.8764H19.6337L19.8918 11.305H16.7068C16.7068 11.305 16.714 9.71637 16.7068 9.25501C16.7068 8.12545 17.8822 8.19014 17.9529 8.19014C18.5122 8.19014 19.5997 8.19177 19.8788 8.19014V4.60425H19.8772Z"
					fill="white"
				/>
			</svg>
		);
	}

	if (type === "fairbid") {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				version="1.1"
				id="Layer_1"
				viewBox="0 0 35 35"
				width="35"
				height="35"
				enableBackground="new 0 0 127 35"
				xmlSpace="preserve"
			>
				<path
					fill="#00D691"
					d="M0,0.1v34.4h7.8c0-10.5,4.8-15.6,14-15.6h7.5v7.1h-4.1h-2.4c-4.7,0-8,1.4-7.8,8.5h22.8V0.1H0z M29.3,15.7H8.6  V8.6h20.7V15.7z"
				/>{" "}
			</svg>
		);
	}

	if (type === "googleAdwords") {
		return (
			<svg
				width="33"
				height="30"
				viewBox="0 0 33 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="14.541"
					width="9.62876"
					height="29.0817"
					rx="4.81438"
					transform="rotate(30 14.541 0)"
					fill="#FABC04"
				/>
				<rect
					x="9.72461"
					y="4.81445"
					width="9.62876"
					height="29.0817"
					rx="4.81438"
					transform="rotate(-30 9.72461 4.81445)"
					fill="#3C8BD9"
				/>
				<ellipse
					cx="6.56721"
					cy="23.4259"
					rx="4.81135"
					ry="4.81135"
					fill="#34A852"
				/>
			</svg>
		);
	}

	if (type === "googlePlay") {
		return (
			<svg
				width="27"
				height="30"
				viewBox="0 0 27 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M16.8198 9.14431L0.966766 0.0836053C0.767559 -0.0320633 0.516943 -0.0256372 0.324162 0.0900314C0.124955 0.2057 0.00286051 0.411333 0.00286051 0.64267C0.00286051 0.64267 -0.00357222 1.46313 0.00285381 2.8383L11.5633 14.4008L16.8198 9.14431Z"
					fill="url(#paint0_linear)"
				/>
				<path
					d="M0.00292969 2.83838L0.00293114 25.9588L11.5698 14.4009L0.00292969 2.83838Z"
					fill="url(#paint1_linear)"
				/>
				<path
					d="M25.8931 14.3301L16.8196 9.14429L11.5566 14.4008L17.4943 20.3384L25.8995 15.4418C26.0988 15.3261 26.2208 15.1141 26.2208 14.8892C26.2208 14.6578 26.0923 14.4458 25.8931 14.3301Z"
					fill="url(#paint2_linear)"
				/>
				<path
					d="M0.00292969 25.9587C0.0157818 28.0986 0.0269322 29.3371 0.0269322 29.3371C0.0269322 29.5684 0.25355 29.804 0.452757 29.9132C0.651964 30.0289 0.896154 30.0289 1.09536 29.9132L17.501 20.3449L11.5634 14.4072L0.00292969 25.9587Z"
					fill="url(#paint3_linear)"
				/>
				<defs>
					<linearGradient
						id="paint0_linear"
						x1="0.00285967"
						y1="7.20326"
						x2="16.8227"
						y2="7.20326"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#63BE6B" />
						<stop offset="0.506" stopColor="#5BBC6A" />
						<stop offset="1" stopColor="#4AB96A" />
					</linearGradient>
					<linearGradient
						id="paint1_linear"
						x1="0.0127049"
						y1="14.3555"
						x2="11.5631"
						y2="14.3555"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#3EC6F2" />
						<stop offset="1" stopColor="#45AFE3" />
					</linearGradient>
					<linearGradient
						id="paint2_linear"
						x1="11.5628"
						y1="14.7455"
						x2="26.2193"
						y2="14.7455"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FAA51A" />
						<stop offset="0.387" stopColor="#FAB716" />
						<stop offset="0.741" stopColor="#FAC412" />
						<stop offset="1" stopColor="#FAC80F" />
					</linearGradient>
					<linearGradient
						id="paint3_linear"
						x1="0.115005"
						y1="22.2034"
						x2="17.5008"
						y2="22.2034"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#EC3B50" />
						<stop offset="1" stopColor="#E7515B" />
					</linearGradient>
				</defs>
			</svg>
		);
	}

	if (type === "harvest") {
		return (
			<svg
				version="1.0"
				xmlns="http://www.w3.org/2000/svg"
				width="35"
				height="35"
				viewBox="0 0 63.000000 92.000000"
				preserveAspectRatio="xMidYMid meet"
			>
				<g
					transform="translate(0.000000,92.000000) scale(0.100000,-0.100000)"
					fill="#f36b1f"
					stroke="none"
				>
					<path
						d="M90 475 l0 -345 65 0 65 0 0 150 0 150 95 0 95 0 0 -150 0 -150 65 0
65 0 0 345 0 345 -65 0 -65 0 0 -135 0 -135 -95 0 -95 0 0 135 0 135 -65 0
-65 0 0 -345z"
					/>
				</g>
			</svg>
		);
	}

	if (type === "snapchat") {
		return (
			<svg
				width="30"
				height="30"
				viewBox="0 0 30 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0 22.3695V22.3709C0.0179546 23.0368 0.0234927 23.7066 0.135826 24.3685C0.254862 25.0687 0.425023 25.7515 0.749663 26.387C1.18856 27.2472 1.79132 27.9736 2.55218 28.567C3.09845 28.9931 3.69521 29.3313 4.3558 29.5447C5.31906 29.8554 6.3128 29.9745 7.32105 29.9803C7.95011 29.9843 8.57875 30 9.20804 29.9974C13.778 29.9781 18.3481 30.0304 22.9182 29.9692C23.5246 29.9609 24.1212 29.887 24.7163 29.7781C25.8571 29.5693 26.8653 29.0826 27.7279 28.313C28.7332 27.4164 29.4114 26.3191 29.7176 24.9947C29.9179 24.129 29.9681 23.2508 29.9766 22.3694V22.1936C29.9766 22.1254 29.9507 7.21828 29.9483 7.02125C29.9416 6.47998 29.9017 5.9428 29.8002 5.41023C29.6768 4.76124 29.5025 4.12886 29.1917 3.54172C28.8636 2.92141 28.4525 2.36366 27.9441 1.87626C27.1654 1.12951 26.2667 0.601421 25.2205 0.322076C24.2756 0.0698365 23.3116 0.0139907 22.3405 0.0148651C22.3389 0.0146319 22.3352 0.00478012 22.335 0H7.63695C7.63666 0.0050133 7.63648 0.0100267 7.63613 0.0148651C7.08502 0.02495 6.53309 0.020811 5.98478 0.088782C5.38411 0.163457 4.78922 0.275906 4.22067 0.485882C3.32516 0.81711 2.54711 1.33301 1.88249 2.02176C1.12951 2.80209 0.59874 3.70454 0.317121 4.75541C0.0658726 5.69301 0.0111929 6.64927 0.00985209 7.61229"
					fill="#FFFC00"
				/>
				<path
					d="M15.1242 25.3115C15.0619 25.3115 15.0025 25.3092 14.9573 25.307C14.9215 25.3101 14.8845 25.3115 14.8474 25.3115C13.5394 25.3115 12.6649 24.6931 11.8932 24.1471C11.34 23.7564 10.8183 23.3875 10.2072 23.2858C9.90701 23.2361 9.60843 23.2108 9.31993 23.2108C8.80012 23.2108 8.38932 23.2914 8.0894 23.3501C7.90484 23.3861 7.7457 23.417 7.62269 23.417C7.49386 23.417 7.33734 23.3884 7.27211 23.1657C7.22041 22.99 7.18333 22.8198 7.14754 22.6559C7.058 22.2462 6.99306 21.9962 6.83969 21.9725C5.19923 21.7194 4.22997 21.3465 4.0369 20.895C4.01667 20.8475 4.00536 20.7998 4.00286 20.7526C3.99534 20.618 4.09036 20.4999 4.22304 20.4779C5.52579 20.2634 6.68416 19.5748 7.66612 18.4307C8.42681 17.5449 8.80036 16.6986 8.84046 16.6052C8.84221 16.601 8.84425 16.5965 8.84635 16.5925C9.03563 16.2085 9.07329 15.8766 8.95862 15.6064C8.74725 15.1079 8.04719 14.8858 7.58405 14.7389C7.46886 14.7024 7.35991 14.6679 7.27311 14.6335C6.86254 14.4713 6.18732 14.1286 6.27727 13.6557C6.34279 13.3108 6.79894 13.0707 7.16759 13.0707C7.26996 13.0707 7.36066 13.0886 7.43703 13.1245C7.8536 13.3196 8.22837 13.4186 8.55068 13.4186C8.95151 13.4186 9.14511 13.2659 9.19192 13.2226C9.18037 13.0088 9.16627 12.7827 9.15263 12.5689C9.15263 12.5686 9.15234 12.5661 9.15234 12.5661C9.05825 11.0694 8.9409 9.20675 9.41734 8.13862C10.8433 4.94136 13.8675 4.69274 14.7601 4.69274C14.7838 4.69274 15.1491 4.68912 15.1491 4.68912C15.1656 4.68883 15.1835 4.6886 15.2021 4.6886C16.0971 4.6886 19.1275 4.93751 20.5544 8.1367C21.0308 9.20552 20.9134 11.0697 20.819 12.568L20.8146 12.6397C20.8016 12.8431 20.7897 13.0357 20.7796 13.2223C20.8237 13.2629 21.0008 13.4028 21.3612 13.417C21.6685 13.4052 22.0216 13.3068 22.4104 13.1247C22.5306 13.0683 22.6637 13.0566 22.7541 13.0566C22.8906 13.0566 23.0296 13.0831 23.1455 13.1315L23.1516 13.1339C23.4816 13.251 23.6977 13.485 23.7023 13.7309C23.7065 13.9601 23.5361 14.3027 22.6983 14.6336C22.6125 14.6676 22.503 14.7023 22.3874 14.739C21.9238 14.8861 21.2244 15.1081 21.013 15.6063C20.8982 15.8765 20.9359 16.2082 21.1253 16.5922C21.1274 16.5964 21.1292 16.6006 21.1312 16.605C21.1895 16.7417 22.6005 19.959 25.7486 20.4776C25.8813 20.4997 25.9764 20.6179 25.9689 20.7523C25.9661 20.8005 25.9544 20.8488 25.934 20.896C25.7423 21.345 24.7731 21.7173 23.1322 21.9708C22.9781 21.9946 22.9133 22.2435 22.8245 22.651C22.7878 22.8193 22.7505 22.9842 22.6994 23.1576C22.6517 23.3207 22.5455 23.4003 22.3749 23.4003H22.3492C22.2382 23.4003 22.0808 23.3802 21.8824 23.3413C21.5355 23.2738 21.1465 23.211 20.6519 23.211C20.3634 23.211 20.0649 23.2363 19.7644 23.286C19.1539 23.3877 18.6323 23.756 18.0801 24.1463C17.3068 24.6931 16.432 25.3115 15.1242 25.3115Z"
					fill="white"
				/>
				<path
					d="M15.202 4.95203C16.0447 4.95203 18.9463 5.17839 20.3137 8.24402C20.764 9.2535 20.6486 11.0821 20.556 12.5511C20.5415 12.7842 20.5272 13.0102 20.5155 13.2259L20.5106 13.3187L20.5726 13.3877C20.5976 13.4155 20.8316 13.6601 21.3522 13.6802L21.3606 13.6807L21.3693 13.6805C21.7135 13.6674 22.1011 13.5605 22.5221 13.3632C22.5842 13.3342 22.6667 13.3201 22.754 13.3201C22.8535 13.3201 22.9593 13.3388 23.0465 13.3755L23.0597 13.3807C23.2804 13.4581 23.4365 13.6039 23.4389 13.7359C23.4402 13.8105 23.3844 14.0793 22.6018 14.3885C22.5254 14.4187 22.4247 14.4508 22.308 14.4876C21.7987 14.6493 21.0293 14.8933 20.7704 15.5035C20.6246 15.8472 20.6645 16.2528 20.889 16.7089C20.9813 16.9244 22.4349 20.1987 25.7059 20.7376C25.7052 20.7531 25.7013 20.7701 25.6925 20.7901C25.6371 20.9207 25.2847 21.3718 23.0919 21.7102C22.7488 21.7627 22.6647 22.1474 22.5673 22.5945C22.5321 22.7546 22.4963 22.9162 22.4471 23.083C22.432 23.1335 22.4292 23.1363 22.3752 23.1363C22.3677 23.1363 22.359 23.1363 22.3494 23.1363C22.2522 23.1363 22.1046 23.1162 21.9335 23.0826C21.6219 23.0219 21.1962 22.9475 20.6521 22.9475C20.3484 22.9475 20.0355 22.9739 19.7216 23.0263C19.0506 23.1378 18.5049 23.5238 17.9269 23.9323C17.1508 24.4808 16.3486 25.0483 15.1247 25.0483C15.0712 25.0483 15.019 25.0465 14.9668 25.0438L14.953 25.0432L14.9392 25.0443C14.9092 25.0469 14.8789 25.0483 14.848 25.0483C13.6242 25.0483 12.8217 24.4809 12.0459 23.9323C11.4679 23.5238 10.9219 23.1378 10.251 23.0263C9.93736 22.974 9.6242 22.9475 9.32067 22.9475C8.77661 22.9475 8.35042 23.0307 8.03948 23.0915C7.86838 23.125 7.72026 23.1536 7.62331 23.1536C7.54392 23.1536 7.5424 23.149 7.52561 23.0916C7.47641 22.9246 7.44045 22.7592 7.40541 22.5993C7.30771 22.1517 7.22359 21.765 6.88065 21.7124C4.68803 21.3737 4.33558 20.9218 4.27997 20.7916C4.27128 20.7711 4.26738 20.7536 4.2665 20.7381C7.53739 20.1996 8.99072 16.9252 9.08335 16.7089C9.30819 16.2531 9.34806 15.8476 9.2018 15.5035C8.94286 14.8936 8.17361 14.6493 7.6647 14.4879C7.54771 14.4508 7.44697 14.4187 7.37043 14.3885C6.70961 14.1274 6.50634 13.8643 6.53654 13.705C6.57157 13.5212 6.89021 13.3343 7.16827 13.3343C7.23076 13.3343 7.28556 13.3444 7.32607 13.3633C7.77768 13.575 8.18993 13.6823 8.55153 13.6823C9.11996 13.6823 9.37296 13.4178 9.40012 13.3876L9.46174 13.3187L9.45678 13.2264C9.4453 13.0108 9.43113 12.7849 9.41621 12.5523C9.32393 11.083 9.20851 9.25555 9.6586 8.24601C11.0209 5.19162 13.9084 4.95617 14.7608 4.95617C14.7818 4.95617 15.1524 4.95238 15.1524 4.95238C15.1675 4.95227 15.1844 4.95203 15.202 4.95203ZM15.202 4.42517H15.201C15.1816 4.42517 15.1634 4.42517 15.146 4.4254C15.0075 4.4268 14.7798 4.42902 14.7593 4.42925C14.26 4.42925 13.2609 4.49979 12.1877 4.97349C11.5741 5.24415 11.0222 5.61012 10.5473 6.06126C9.98114 6.59879 9.51992 7.26153 9.17668 8.03137C8.67401 9.15854 8.79334 11.0571 8.88917 12.5829L8.88952 12.5853C8.89978 12.7487 8.91057 12.9193 8.92042 13.0855C8.84668 13.1194 8.72711 13.1551 8.55089 13.1551C8.26735 13.1551 7.93018 13.0645 7.54899 12.8859C7.43683 12.8336 7.30882 12.8072 7.16757 12.8072C6.94063 12.8072 6.70139 12.874 6.49386 12.9961C6.23276 13.1494 6.06406 13.366 6.01824 13.6063C5.98805 13.7652 5.9895 14.0793 6.33839 14.3978C6.5303 14.5731 6.81221 14.7348 7.17608 14.8787C7.27157 14.9163 7.38489 14.9522 7.50492 14.9902C7.92143 15.1226 8.55182 15.3226 8.71621 15.7095C8.79952 15.9057 8.76366 16.1638 8.60994 16.4758C8.60592 16.4843 8.6019 16.4927 8.59823 16.5014C8.55981 16.5911 8.20142 17.4029 7.46627 18.2591C7.04853 18.746 6.58842 19.1529 6.09945 19.4688C5.50263 19.8545 4.85685 20.1067 4.18023 20.2182C3.91452 20.2618 3.72477 20.4985 3.73958 20.7675C3.74413 20.8451 3.76231 20.9224 3.79385 20.9972C3.79408 20.9976 3.79438 20.9981 3.79461 20.9985C3.90205 21.2498 4.15114 21.4633 4.55611 21.6516C5.05097 21.8814 5.79107 22.0748 6.75566 22.2261C6.8044 22.3188 6.855 22.5517 6.89003 22.7112C6.9267 22.8807 6.96494 23.055 7.01944 23.2402C7.07826 23.4407 7.23082 23.6804 7.62273 23.6804C7.77126 23.6804 7.94207 23.647 8.13986 23.6086C8.42952 23.5518 8.82563 23.4743 9.32002 23.4743C9.59412 23.4743 9.87819 23.4984 10.1641 23.5459C10.7153 23.6377 11.1905 23.9733 11.7402 24.362C12.5449 24.9309 13.4558 25.5747 14.8474 25.5747C14.8854 25.5747 14.9234 25.5735 14.961 25.5709C15.007 25.573 15.064 25.5747 15.1242 25.5747C16.5163 25.5747 17.4269 24.9306 18.2307 24.3623L18.232 24.3611C18.7819 23.9728 19.2565 23.6377 19.8075 23.5459C20.0933 23.4985 20.3773 23.4743 20.6515 23.4743C21.1238 23.4743 21.4978 23.5345 21.8317 23.5996C22.0496 23.6425 22.219 23.6631 22.3489 23.6631L22.3616 23.6634H22.3748C22.6614 23.6634 22.872 23.506 22.9524 23.2307C23.0058 23.0495 23.0439 22.8793 23.0815 22.7069C23.1143 22.5574 23.1666 22.3178 23.2154 22.2241C24.1806 22.0726 24.9204 21.8796 25.4153 21.6498C25.8194 21.4624 26.0682 21.2492 26.1763 20.9989C26.2087 20.9239 26.2276 20.8461 26.2319 20.767C26.2471 20.4984 26.0571 20.2612 25.7912 20.2176C22.7841 19.722 21.4294 16.6322 21.3733 16.5009C21.3697 16.4922 21.3656 16.4837 21.3614 16.4753C21.2077 16.1632 21.1722 15.9054 21.2555 15.7089C21.4196 15.3223 22.0496 15.1223 22.4664 14.99C22.587 14.952 22.7008 14.9159 22.7955 14.8784C23.2058 14.7164 23.4991 14.5406 23.6926 14.3409C23.9237 14.1029 23.9687 13.8748 23.9659 13.7256C23.9588 13.3645 23.6828 13.0437 23.2437 12.8866C23.0954 12.8252 22.9263 12.7929 22.7541 12.7929C22.6369 12.7929 22.4633 12.809 22.2989 12.8857C21.9471 13.0503 21.632 13.1403 21.3615 13.1532C21.2176 13.1459 21.1167 13.1147 21.0513 13.0849C21.0595 12.9441 21.0686 12.7994 21.078 12.6485L21.0819 12.5839C21.1783 11.0572 21.298 9.15714 20.7951 8.02915C20.4504 7.25658 19.9876 6.59214 19.4191 6.05344C18.9424 5.60201 18.3886 5.2361 17.7728 4.96562C16.7011 4.49542 15.7021 4.42517 15.202 4.42517Z"
					fill="#020202"
				/>
			</svg>
		);
	}

	if (type === "tiktok") {
		return (
			<svg
				enableBackground="new 0 0 512 512"
				height="35"
				viewBox="0 0 512 512"
				width="35"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="m475.074 0h-438.148c-20.395 0-36.926 16.531-36.926 36.926v438.148c0 20.395 16.531 36.926 36.926 36.926h438.148c20.395 0 36.926-16.531 36.926-36.926v-438.148c0-20.395-16.531-36.926-36.926-36.926zm-90.827 195.959v34.613c-16.322.006-32.181-3.192-47.137-9.503-9.617-4.06-18.577-9.292-26.772-15.613l.246 106.542c-.103 23.991-9.594 46.532-26.772 63.51-13.98 13.82-31.695 22.609-50.895 25.453-4.512.668-9.103 1.011-13.746 1.011-20.553 0-40.067-6.659-56.029-18.943-3.004-2.313-5.876-4.82-8.612-7.521-18.617-18.4-28.217-43.34-26.601-69.575 1.234-19.971 9.229-39.017 22.558-53.945 17.635-19.754 42.306-30.719 68.684-30.719 4.643 0 9.234.348 13.746 1.017v12.798 35.601c-4.277-1.411-8.846-2.187-13.603-2.187-24.1 0-43.597 19.662-43.237 43.779.228 15.431 8.658 28.92 21.09 36.355 5.842 3.495 12.564 5.659 19.737 6.053 5.62.308 11.016-.474 16.013-2.124 17.218-5.688 29.639-21.861 29.639-40.935l.057-71.346v-130.252h47.668c.046 4.723.525 9.332 1.416 13.797 3.598 18.075 13.786 33.757 27.966 44.448 12.364 9.326 27.76 14.854 44.448 14.854.011 0 .148 0 .137-.011v12.843z" />
			</svg>
		);
	}

	if (type === "unity") {
		return (
			<svg
				width="30"
				height="30"
				viewBox="0 0 30 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M19.0829 15.0009L24.333 5.93532L26.8698 15.0009L24.3328 24.0643L19.0829 15.0009ZM16.524 16.4731L21.7748 25.5372L12.6302 23.1945L6.02383 16.4731H16.524ZM21.7737 4.46195L16.524 13.5275H6.02383L12.6302 6.80569L21.7737 4.46195ZM29.2685 11.9157L26.0656 0L14.1108 3.1934L12.3411 6.30469L8.7502 6.27896L0 15.0017L8.7502 23.7224H8.75054L12.34 23.6959L14.1121 26.8072L26.0656 30L29.2683 18.0866L27.4494 15.001L29.2683 11.9159L29.2685 11.9157Z"
					fill="#222C37"
				/>
			</svg>
		);
	}

	return (
		<Icon
			className="text-blue-500"
			name="chart-network"
			weight="solid"
			size="large"
		/>
	);
};

export const feedTypeToBrand = (feedType: Feed): Type => {
	switch (feedType) {
		case "APPLE":
			return "apple";
		case "APPSFLYER_CAMPAIGN":
		case "APPSFLYER_DATALOCKER":
		case "APPSFLYER_RAW_EVENTS":
		case "APPSFLYER_RAW_INSTALLS":
		case "APPSFLYER_SCRAPER":
			return "appsFlyer";
		case "FACEBOOK_ADS":
			return "facebook";
		case "FAIRBID_USER_REPORT":
			return "fairbid";
		case "GOOGLE_ADWORDS":
			return "googleAdwords";
		case "GOOGLE_PLAY":
			return "googlePlay";
		case "HARVEST":
			return "harvest";
		case "SNAPCHAT":
			return "snapchat";
		case "TIKTOK_ADS_AUDIENCE":
			return "tiktok";
		case "UNITY_ADS":
		case "UNITY_ADVERTISER":
			return "unity";
		default:
			return "default";
	}
};

export const accessTypeToBrand = (accessType: AccessType): Type => {
	return accessType === AccessType.appleAccesses
		? "apple"
		: accessType === AccessType.awsProjects
		? "awsProject"
		: accessType === AccessType.appsFlyerAccesses
		? "appsFlyer"
		: accessType === AccessType.facebookAdsAccesses
		? "facebook"
		: accessType === AccessType.fairbidAccesses
		? "fairbid"
		: accessType === AccessType.googleAdsAccesses
		? "googleAdwords"
		: accessType === AccessType.googlePlayAccesses
		? "googlePlay"
		: accessType === AccessType.harvestAccesses
		? "harvest"
		: accessType === AccessType.snapchatAccesses
		? "snapchat"
		: accessType === AccessType.tiktokAccesses
		? "tiktok"
		: accessType === AccessType.unityAccesses
		? "unity"
		: "default";
};
